import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";
import { PackageState } from "models/package";

const initialState: PackageState = {
  loading: false,
  data: {},
  moduleListData: [],
  moduleListSuccess: false,
  moduleListMessage: "",
  addPackageMessage: "",
  message: "",
  success: false,
  updateMessage: "",
  addPackageLoading: false,
  updatePackageMessage: "",
  updatePackageLoading: false,
  deleteLoading: false,
  deleteMessage: "",
  moduleListLoading: false,
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    getPackages(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getPackagesSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getPackagesFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    addPackage(state, action: PayloadAction<ApiResponse>) {
      state.addPackageLoading = true;
      state.addPackageMessage = "";
    },
    addPackageSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addPackageLoading = false;
      state.addPackageMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addPackageFailed(state, action: PayloadAction<ApiResponse>) {
      state.addPackageLoading = false;
      state.addPackageMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updatePackage(state, action: PayloadAction<ApiResponse>) {
      state.updatePackageLoading = true;
      state.updatePackageMessage = "";
    },
    updatePackageSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updatePackageLoading = false;
      state.updatePackageMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updatePackageFailed(state, action: PayloadAction<ApiResponse>) {
      state.updatePackageLoading = false;
      state.updatePackageMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deletePackage(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deletePackageSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deletePackageFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteLoading = false;
      state.deleteMessage = action.payload.message;
      state.success = action.payload.success;
    },
    getModuleList(state, action: PayloadAction<ApiResponse>) {
      state.moduleListLoading = true;
      state.moduleListMessage = "";
    },
    getModuleListSuccess(state, action: PayloadAction<ApiResponse>) {
      state.moduleListLoading = false;
      state.moduleListData = action.payload.moduleNameData;
      state.moduleListSuccess = action.payload.success;
    },
    getModuleListFailed(state, action: PayloadAction<ApiResponse>) {
      state.moduleListLoading = false;
      state.moduleListMessage = action.payload.message;
      state.moduleListSuccess = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.addPackageLoading = false;
      state.addPackageMessage = "";
      state.updateMessage = "";
      state.deleteMessage = "";
      state.updatePackageMessage = "";
      state.updatePackageLoading = false;
      state.deleteMessage = "";
      state.deleteLoading = false;
      state.moduleListLoading = false;
      state.moduleListMessage = "";
    },
  },
});

//Actions
export const packageActions = packageSlice.actions;

//Selectors
export const getPackageData = (state: RootState) => state.package.data;
export const getPackageDataLoad = (state: RootState) => state.package.loading;
export const addPackageIsLoading = (state: RootState) =>
  state.package.addPackageLoading;
export const addPAckageIsMessage = (state: RootState) =>
  state.package.addPackageMessage;
export const moduleListData = (state: RootState) =>
  state.package.moduleListData;
export const updatePackageMessage = (state: RootState) =>
  state.package.updatePackageMessage;
export const updatePackageLoading = (state: RootState) =>
  state.package.updatePackageLoading;
export const deletePackageLoad = (state: RootState) =>
  state.package.deleteLoading;
export const deletePackageMsg = (state: RootState) =>
  state.package.deleteMessage;
export const brandListData = (state: RootState) =>
  state.brandLocation.brandListData;
export const documnetLoading = (state: RootState) =>
  state.document.documentloading;
export const documentUrlBack = (state: RootState) => state.document.documentUrl;

//Reducers
const packageReducer = packageSlice.reducer;
export default packageReducer;
